import type { ReactNode } from 'react'

import Link from 'next/link'
import { ChevronLeft } from 'lucide-react'
import { cn } from '@/lib/utils'

export type Crumb = {
    label: ReactNode
    href?: string
}

interface BreadcrumbsProps {
    items: Array<Crumb>
    className?: string
}

export const Breadcrumbs = ({ items, className }: BreadcrumbsProps): ReactNode => {
    return (
        <nav aria-label="مسیر صفحه" className={className}>
            <ol className='flex flex-wrap items-center gap-1.5 text-xs text-muted-foreground sm:text-sm'>
                {items.map((item, index) => {
                    const last = index === items.length - 1

                    return (
                        <li key={index} className='inline-flex min-w-0 items-center gap-1.5'>
                            {item.href && !last ? (
                                <Link href={item.href} className='rounded-md transition-colors hover:text-primary'>
                                    {item.label}
                                </Link>
                            ) : (
                                <span className={cn('truncate', last && 'font-semibold text-foreground')} aria-current={last ? 'page' : undefined}>
                                    {item.label}
                                </span>
                            )}
                            {!last && <ChevronLeft className='size-3.5 shrink-0 opacity-60' aria-hidden='true' />}
                        </li>
                    )
                })}
            </ol>
        </nav>
    )
}

interface PageBackdropProps {
    className?: string
}

export const PageBackdrop = ({ className }: PageBackdropProps): ReactNode => {
    return (
        <div className={cn('pointer-events-none absolute inset-x-0 top-0 -z-10 h-[30rem] overflow-hidden', className)} aria-hidden='true'>
            <div className='absolute inset-0 bg-grid opacity-60 fade-bottom' />
            <div className='absolute -top-40 right-[-8%] size-[30rem] rounded-full bg-lavender/60 blur-3xl' />
            <div className='absolute -top-32 left-[-10%] size-[26rem] rounded-full bg-sky/60 blur-3xl' />
        </div>
    )
}
